import React, { useState, useContext } from 'react';
import ShareSendEmailPopUpContent from './ShareSendEmailPopUpContent';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import PopUp from './PopUp';
import calculatePrice from '../../helpers/calculatePrice';

const getImageFromCanvas = () => {
  return new Promise(resolve => {
    setTimeout(() => {
      const canvasRenderer = window.brwRenderer;
      canvasRenderer.render(window.brwScene, window.brwCamera);
      resolve(canvasRenderer.domElement.toDataURL());
    }, 100);
  });
};

const ShareSendEmailPopUp = props => {
  const [sended, setSended] = useState(false);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);

  const getImageFromCanvasOpenDoor = async () => {
    props.setOpenDoorsState(true);
    const blob = await getImageFromCanvas();
    return blob;
  };

  const getImageFromCanvasCloseDoor = async () => {
    props.setOpenDoorsState(false);
    const blob = await getImageFromCanvas();
    return blob;
  };

  const getPricesInfo = () => {
    let wardrobesPrices = [];
    wardrobesConfigs.forEach(element => {
      wardrobesPrices.push(calculatePrice(element));
    });

    return wardrobesPrices;
  };

  return (
    <PopUp
      title="Powrót"
      popupName="share-email-send-popup"
      additionalFunc={() => setSended(false)}>
      <ShareSendEmailPopUpContent
        imageOpen={getImageFromCanvasOpenDoor}
        imageClose={getImageFromCanvasCloseDoor}
        prices={getPricesInfo}
        sended={sended}
        setSended={() => setSended(true)}
      />
    </PopUp>
  );
};

export default ShareSendEmailPopUp;
